import { graphql } from "react-relay";

export const UpdateJiraInstanceMutation = graphql`
  mutation UpdateJiraInstanceMutation($input: UpdateJiraInstanceInput!) {
    updateJiraInstance(input: $input) {
      jiraInstance {
        clientId
        defaultSpace {
          key
          name
        }
        defaultWorkType {
          name
        }
        error
        id
        issueLimitHard
        issueLimitSoft
        name
        spaces {
          key
          name
          workTypes {
            iconUrl
            name
          }
        }
        spacesUpdated
        updatePending
        url
        username
        uuid
      }
      problems {
        message
      }
    }
  }
`;
